export const HORIZONTAL_DESCRIPTORS = [
  'DURATION',
  'FREE_CANCELLATION',
  'TRANSFERS',
  'EXTENDED_VALIDITY',
];
